import { render, staticRenderFns } from "./PreviousClaimsForm.vue?vue&type=template&id=462d840c&scoped=true&"
import script from "./PreviousClaimsForm.vue?vue&type=script&lang=js&"
export * from "./PreviousClaimsForm.vue?vue&type=script&lang=js&"
import style0 from "./PreviousClaimsForm.vue?vue&type=style&index=0&id=462d840c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462d840c",
  null
  
)

export default component.exports